export const BROWSER_STORAGE_KEYS = {
  HAS_PASSWORD: 'has_password',
  UNPAID_INVOICE_POPUP_SEEN: 'unpaid_invoice_popup_seen',
  WEEKEND_PAYOUT_BANNER_DISMISSED_AT: 'weekend_payout_banner_dismissed_at',
  PEAK_HOUR_BONUS_BANNER_DISMISSED_AT: 'peak_hour_bonus_banner_dismissed_at',
  AI_COLLECTION_OFFER_BANNER_DISMISSED_AT:
    'ai_collection_offer_banner_dismissed_at',
  EXPLORE_MORE_CROSS_SELL_DISMISSED_AT: 'explore_more_cross_sell_dismissed_at',
}
